import { Subscribable, SubscribableOrNullableValue } from 'knockout';

interface SurveyStatisticsQuestionChoiceConfig {
    questionChoiceId: SubscribableOrNullableValue<string>
    title: SubscribableOrNullableValue<string>
    value: SubscribableOrNullableValue<string>
    rank: SubscribableOrNullableValue<string>
    scoremode: SubscribableOrNullableValue<boolean>
}

export default class SurveyStatisticsQuestionChoice {
    questionChoiceId: Subscribable<string | undefined>
    title: Subscribable<string | undefined>
    value: Subscribable<string | undefined>
    rank: Subscribable<string | undefined>
    scoremode: Subscribable<boolean>

    constructor(config: SurveyStatisticsQuestionChoiceConfig) {
        this.questionChoiceId = ko.flattenComputed(config.questionChoiceId);
        this.title = ko.flattenComputed(config.title);
        this.value = ko.flattenComputed(config.value);
        this.rank = ko.flattenComputed(config.rank);

        this.scoremode = ko.flattenComputed(config.scoremode, false);
    }
}